import type { LeaseActionProps } from '../../../models/Types';

export default function RedirectToPayments({ property, lease, terminateActiveAction }: LeaseActionProps) {
  // Updating location directly, otherwise blank page is rendered
  // history.push and <Redirect> didn't work.
  window.location.href = property.getPaymentsDashboardPath(lease.encodedId);

  terminateActiveAction();
  return null;
}
